import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import {
  Shield, Database, Bell, Lock, LogOut, ChevronRight
} from 'lucide-react';

/**
 * AdminSettings — System-level configuration for admin users.
 */
const AdminSettings = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/welcome');
  };

  const items = [
    { icon: Shield, label: 'Compliance & Audit', desc: 'HIPAA compliance settings and audit logs', path: '/admin/compliance' },
    { icon: Database, label: 'Data Management', desc: 'Backup, export, and retention policies', path: '/admin/data-management' },
    { icon: Bell, label: 'System Notifications', desc: 'Global notification rules and escalation', path: '/admin/notifications' },
    { icon: Lock, label: 'Access Control', desc: 'Role permissions and access policies', path: '/admin/access-control' },
  ];

  return (
    <div className="space-y-6 py-6">
      <div>
        <h2 className="font-headline text-2xl font-extrabold text-slate-900 tracking-tight">System Settings</h2>
        <p className="text-slate-500 text-sm mt-1">Global platform configuration</p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-outline-variant/10 overflow-hidden">
        {items.map((item, i) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-all ${
                i > 0 ? 'border-t border-slate-100' : ''
              }`}
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-sm font-bold text-slate-900">{item.label}</p>
                  <p className="text-xs text-slate-500">{item.desc}</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-500" />
            </button>
          );
        })}
      </div>

      <button
        onClick={handleLogout}
        className="w-full flex items-center justify-center gap-3 p-4 bg-red-50 text-red-600 rounded-2xl font-bold hover:bg-red-100 transition-all"
      >
        <LogOut className="w-5 h-5" />
        Log Out
      </button>
    </div>
  );
};

export default AdminSettings;
